import update from 'immutability-helper';

import {
	SHOW_FEEDBACK,
	HIDE_FEEDBACK,
	RESTART_EXERCISE,
	RECOVER_SAVED_STATE
} from '../actions/types';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case SHOW_FEEDBACK: {
			return update(state, {
				[action.payload.index]: {
					$set: {
						visible: true,
						type: action.payload.type,
						loading: action.payload.loading,
						messageId: action.payload.messageId,
					}
				},
			});
		}

		case HIDE_FEEDBACK: {
			return update(state, {
				[action.payload.index]: {
					$set: {
						visible: false
					}
				},
			});
		}

		case RESTART_EXERCISE:
			return INITIAL_STATE;

		case RECOVER_SAVED_STATE: {
			return update(state, {
				$set: action.payload.feedback
			});
		}

		default:
			return state;
	}
}
